import React from 'react';
import { Form } from 'react-form';

import { Input } from '../../../components/Form';
import { required } from '../../../utils/validation';

const ProfileSearchForm = (props) => {
    const { firstName, lastName, onSearchSubmit } = props;

    const defaultValues = {
        firstName,
        lastName,
    };

    const handleSubmit = (values) => {
        props.fetchMatchingProfiles(values.firstName, values.lastName);
        onSearchSubmit(true);
    };

    return (
        <Form
            onSubmit={values => handleSubmit(values)}
            defaultValues={defaultValues}
        >
            {({ submitForm }) => {
                return (
                    <form onSubmit={submitForm} id="ProfileSearchForm" data-testid="nuo-v2.profile-search.form">
                        <div className={`row`}>
                            <div className={`col-12`}>
                                <Input
                                    id="firstName"
                                    field="firstName"
                                    type="text"
                                    label="First Name"
                                    validate={required}
                                    themeV3
                                    data-testid="nuo-v2.profile-search.first-name-input"
                                />
                            </div>
                            <div className={`col-12`}>
                                <Input
                                    id="lastName"
                                    field="lastName"
                                    type="text"
                                    label="Last Name"
                                    validate={required}
                                    themeV3
                                    data-testid="nuo-v2.profile-search.last-name-input"
                                />
                            </div>
                            <div className={`col-12`}>
                                <div className="form-group mb0">
                                    <button
                                        type="submit"
                                        className={`btn btn-primary text-uppercase btn-block`}
                                        data-testid="nuo-v2.profile-search.search-btn"
                                    >
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                );
            }}
        </Form>
    );
};

export default ProfileSearchForm;
